module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap1"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_vm._v("FIRST AMERICAN PUBLICATION OF A MODERN CLASSIC …")])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("England in the late 18th Century—a lusty, brawling isle, vital, colorful, conspicuously sceptered, a hallowed plot in fullest flower, vigorously burgeoning, teeming, seething in ferment as the British spirit sought dominion over half the world. It was an adventurous era of plenty, and of cruel want: Appalling poverty and fabulous riches lived side by side. It was an age at cross-purposes with itself: Moral laxity and high achievement were accepted companions. It was an age of brilliant enlightenment, and of spectacular abandonment to unworthy pursuits and seamy pleasures. It was a beginning—and an end.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("This is the England of "), _c('i', [_vm._v("I, Libertine.")]), _vm._v(" In bringing to life the temper of these tempestuous years, Frederick R. Ewing has created an unforgettable hero, Lance Courtenay, who strove to overcome his clouded origin by ruthlessly exploiting the men who befriended him and the women who loved him. Already a resounding success in England and on the Continent, this controversial novel is now available, for the first time, to the American public which has so eagerly anticipated its publication in this country.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bca2a2f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-chap1.vue
// module id = 72
// module chunks = 0